import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider, createRouter, createHashHistory, createBrowserHistory } from "@tanstack/react-router";
import { store } from "./store";
import { routeTree } from "./routeTree.gen";
import "./index.css";
import { ThemeProvider } from "./context/ThemeContext";
import { ToastContainer } from "react-toastify";
import { Order } from "./interfaces";

interface RouterContext {
  store: typeof store;
}
const isElectron = !!window.electron?.isElectron || window.location.protocol === 'file:';
const routerHistory = isElectron ? createHashHistory() : createBrowserHistory();

const router = createRouter<
  typeof routeTree,
  any, // LoaderData type, replace 'any' with your actual type if needed
  any, // SearchSchema type, replace 'any' with your actual type if needed
  any, // RouteContext type, replace 'any' with your actual type if needed
  RouterContext // RouterContext type
>({
  routeTree,
  history: routerHistory,
  defaultPreload: "intent",
  context: {
    store: undefined as unknown as RouterContext["store"],
  },
});

// Add to your main.tsx after router creation
declare module '@tanstack/react-router' {
  interface Register {
    router: {
      state: {
        order?: Order;
      };
    } & typeof router;
  }
}

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ToastContainer position="bottom-right" />
      <ThemeProvider>
        <RouterProvider router={router} context={{ store }} />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
